import {Component, OnDestroy, OnInit} from '@angular/core';
import {FeatureTypeService} from '@catcore/services';
import {Feature} from '@catcore/services/feature/feature';
import {FeatureToProjectComponent} from '@catfeatures/components/feature-to-project/feature-to-project.component';
import {BreadcrumbService} from '@catmodules/widgets/breadcrumb/services/breadcrumb.service';
import {Item} from '@catmodules/widgets/breadcrumb/types';
import {ModalService} from '@catmodules/widgets/slide-in-modal/services/modal.service';
import {MenuItem} from '@catui/types';
import 'rxjs/add/operator/delay';
import {isNullOrUndefined} from 'util';

/**
 * Container component to display header and main content information for one or many features
 *
 * It handles the behaviour to update the current breadcrumb information and
 * also to initialize the assignment of the current selected Feature to a Project
 *
 */
@Component({
  templateUrl: './features.component.html',
})
export class FeaturesComponent implements OnInit, OnDestroy {
  breadcrumbs: Item[] = [];
  featureOptions: MenuItem[] = [];

  private currentFeature: Feature;

  constructor(private breadcrumbService: BreadcrumbService,
              private featureService: FeatureTypeService,
              private modalService: ModalService) {
  }

  /**
   * Initialize and updates the breadcrumb service according to the current context
   * Handles incoming Feature as the current in use Feature
   */
  ngOnInit() {
    const defaultBreadcrumbRoot = [{label: 'Features', value: null}];
    this.breadcrumbService
      .current$
      .subscribe((breadcrumbs) => this.breadcrumbs = breadcrumbs);

    this.breadcrumbService
      .setRoot(defaultBreadcrumbRoot);

    this.featureService
      .getCurrent()
      .delay(100)
      .subscribe((feature: Feature) => {
        const doUpdatesForFeature = !isNullOrUndefined(feature);
        const hasFeatureChanged = doUpdatesForFeature && (!isNullOrUndefined(this.currentFeature) && feature.id !== this.currentFeature.id);

        if (doUpdatesForFeature) {
          this.currentFeature = feature;
          this.breadcrumbService
            .setRoot([...defaultBreadcrumbRoot, {label: feature.name, value: null}], !hasFeatureChanged);

          this.featureOptions = this.buildOptionsForFeature(feature);
        }
      });
  }

  ngOnDestroy() {
    this.featureService.resetCurrent();
  }

  /**
   * Returns a list of options that a only available if a Feature is currently active
   * @param {Feature} feature
   * @returns {MenuItem[]}
   */
  private buildOptionsForFeature(feature: Feature): MenuItem[] {
    const menuItems: MenuItem[] = [];

    if (!isNullOrUndefined(feature)) {
      menuItems.push({
        label: 'Assign to Project',
        sticky: true,
        command: () => {
          this.openFeatureToProjectDialog(feature);
        },
      });
    }
    return menuItems;
  }

  /**
   * Initilize a modal dialog
   *
   * @param {Feature} feature
   */
  private openFeatureToProjectDialog(feature: Feature) {
    const component = this.modalService.open(FeatureToProjectComponent);
    component.componentInstance.feature = feature;
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/features/components/features/features.component.ts